import makeStyles from "@material-ui/core/styles/makeStyles";

import { theme } from "theme";

export const useStyles = makeStyles(() => ({
  root: {
    "& .Mui-disabled": {
      opacity: "0.5",
    },

    ////////////////////////
    // Bordure de l'input //
    ////////////////////////

    // Bordure par défaut
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: theme.colors.light300,
      borderRadius: 0,
    },

    // Bordure au hover si le champ n'est pas désactivé
    "&:hover .MuiOutlinedInput-root:not('.Mui-disabled') .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: theme.colors.light000,
    },

    // Bordure au focus
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "2px",
      borderColor: theme.colors.light000,
    },

    // Bordure quand il y a une erreur
    "&.ERROR .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1.5px",
      borderColor: theme.colors.red500,
    },

    // Bordure quand le champ est valide
    "&.SUCCESS .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1.5px",
      borderColor: theme.colors.green500,
    },

    ////////////
    // Label ///
    ////////////

    // couleur du label par défaut
    "& .MuiFormLabel-root": {
      color: theme.colors.light000,
    },

    // couleur du label quand il est en erreur
    "&.ERROR .MuiFormLabel-root, &.ERROR .MuiFormLabel-filled, &.ERROR label.MuiInputLabel-shrink": {
      color: theme.colors.red500,
    },

    // couleur du label quand il est valide
    "&.SUCCESS .MuiFormLabel-root, &.SUCCESS .MuiFormLabel-filled, &.SUCCESS label.MuiInputLabel-shrink": {
      color: theme.colors.green500,
    },

    /////////////////
    // Helper Text //
    /////////////////
    "&.ERROR .MuiFormHelperText-root": {
      color: theme.colors.red500,
    },

    //////////////////
    // EndAdornment //
    //////////////////

    // Couleur de l'icone de l'input en succès
    "&.SUCCESS .MuiInputAdornment-root": {
      color: theme.colors.green500,
    },

    // Couleur de l'icone de l'input en erreur
    "&.ERROR .MuiInputAdornment-root": {
      color: theme.colors.red500,
    },

    ///////////
    // Champ //
    ///////////

    "& input, & textarea": {
      color: theme.colors.light000,
      textOverflow: "ellipsis",
      fontWeight: 500,

      // Permet de garder la couleur de fond de l'input et la couleur du texte
      // S'il a été autofill
      "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active, &:-internal-autofill-selected": {
        webkitAnimationName: "clear",
        webkitAnimationFillMode: "both",
        backgroundColor: "transparent !important",
        // Light800 étant la couleur de fond de l'application
        boxShadow: `inset 200px 200px 0px 0px ${theme.colors.light800}`,
        WebkitTextFillColor: theme.colors.light000,
        color: "transparent",
      },

      // Supprime les icones disgracieuses sous IE
      "&::-ms-clear, &::-ms-reveal": {
        display: "none",
      },

      /**
       * Supprime l'icone d'autofill sous safari
       * absolute makes the input overflow,
       * opacity hides the autofill helper
       */
      "&::-webkit-credentials-auto-fill-button": {
        position: "absolute",
        opacity: 0,
      },
    },
  },
}));
